import api from './api';

export const recommendationsService = {
    async getPersonalizedRecommendations(params = {}) {
        const response = await api.get('/recommendations/personalized/', { params });
        return response.data;
    },

    async getTrendingProducts() {
        const response = await api.get('/recommendations/trending/');
        return response.data;
    },

    async getFeaturedProducts() {
        const response = await api.get('/recommendations/featured/');
        return response.data;
    },

    async getRecommendationsForOccasion(occasionId, params = {}) {
        const response = await api.get(`/recommendations/occasion/${occasionId}/`, { params });
        return response.data;
    },

    async getRecommendationsForContact(contactId, params = {}) {
        const response = await api.get(`/recommendations/${contactId}/contact-recommendations/`, { params });
        return response.data;
    },

    async getRecommendationsByCategory(categoryId, params = {}) {
        const response = await api.get(`/recommendations/category/${categoryId}/`, { params });
        return response.data;
    },

    async getGiftRecommendations(filters = {}) {
        const response = await api.post('/recommendations/gifts/', filters);
        return response.data;
    },

    async recordRecommendationInteraction(recommendationId, action) {
        const response = await api.post(`/recommendations/${recommendationId}/interaction/`, {
            action
        });
        return response.data;
    },

    async getRecommendationInsights() {
        const response = await api.get('/recommendations/insights/');
        return response.data;
    },

    // Additional methods based on backend implementation
    async getRecommendations(params = {}) {
        const response = await api.get('/recommendations/', { params });
        return response.data;
    },

    async getRecommendationById(id) {
        const response = await api.get(`/recommendations/${id}/`);
        return response.data;
    },

    async getBudgetRecommendations(minPrice, maxPrice, params = {}) {
        const response = await api.get('/recommendations/', {
            params: {
                min_price: minPrice,
                max_price: maxPrice,
                ...params
            }
        });
        return response.data;
    }
}; 